import { render } from "./ChartLegendPanel.vue?vue&type=template&id=5d42bad0"
import script from "./ChartLegendPanel.vue?vue&type=script&lang=js"
export * from "./ChartLegendPanel.vue?vue&type=script&lang=js"

import "./ChartLegendPanel.vue?vue&type=style&index=0&id=5d42bad0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/components_core/ChartLegendPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d42bad0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d42bad0', __exports__)) {
    api.reload('5d42bad0', __exports__)
  }
  
  module.hot.accept("./ChartLegendPanel.vue?vue&type=template&id=5d42bad0", () => {
    api.rerender('5d42bad0', render)
  })

}


export default __exports__